import { Directive, TemplateRef } from "@angular/core";

/**
 * Use this directive on an <ng-template> inside <app-card-wrapper> to defer
 * the creation of heavy content (e.g. TinyMCE) until the card is opened.
 *
 * Without this directive, Angular creates projected content as part of the
 * parent view even when the card is folded, which can cause issues with
 * components that rely on being in the DOM during initialization.
 *
 * Usage:
 *   <app-card-wrapper [foldable]="true" [folded]="true">
 *     <ng-template appCardContent>
 *       <app-rich-text ...></app-rich-text>
 *     </ng-template>
 *   </app-card-wrapper>
 */
@Directive({ selector: "ng-template[appCardContent]", standalone: true })
export class CardContentDirective {
  constructor(public readonly templateRef: TemplateRef<void>) {}
}
